import { observable, action } from 'mobx';
import { api } from '../config';

// User Store
import UserStore from './UserStore';

// App Store
import AppStore from './AppStore';



let obx = observable({
    surveyJson: null,
    detailText: null,
    name: null,
/**
 *
 * checkForSurvey - Checks if the requirements have been met to show a survey
 * @param {function} callback - function to be called after api call
*/
checkForSurvey: action((callback) => {
    const { userData } = UserStore;
    const { role } = UserStore.userData;

    const url = `/installs/${UserStore.installSid}/surveys/${role === 'learner' ? UserStore.assessmentGroup.studentSurveySid : UserStore.assessmentGroup.facultySurveySid}/users/${userData.userSid}/checkTriggers`

    api.get(url)
    .then(response => {
        console.log(response.data)
        if (response.data.showSurvey === true) {
            obx.surveyJson = response.data.surveyJson;
            obx.detailText = response.data.detailText;
            obx.name = response.data.name;

            if (callback) {
                console.log('hit')
                callback();
            }
            }
        })


}),
    /**
     *  sendSurveyData - sending an surveyData object to WGU's plg survey bucket
     *  @param {Object} surveyData - survey response object to be uploaded to WGU's S3 bucket
     *
     */
    sendSurveyData: action((surveyData) => {

    const { role } = UserStore.userData;

        // using /plgSurvey/ opposed to /cptSurvey/
    const url = '/surveys/plgSurvey/data'

    const payload = {
        assessmentGroupSid: UserStore.assessmentGroupSid,
        userSid: UserStore.userData.userSid,
        role: role === "learner" ? role : "faculty",
        surveySid: (role === 'learner' ? UserStore.assessmentGroup.studentSurveySid : UserStore.assessmentGroup.facultySurveySid)
    }

    if (surveyData) {
        payload.responseJson = surveyData;
    }

    api.post(url, payload)
    .then(response => {
        console.log(response)
    })
    .catch(error => {
        AppStore.throwError(error);
    })
}),
returnSurveyMetaData: action(() => {
    const { role } = UserStore.userData;

    return {
      assessmentGroupSid: UserStore.assessmentGroupSid,
      userSid: UserStore.userData.userSid,
      role: role === "learner" ? role : "faculty",
      surveySid:
        role === "learner"
        ? UserStore.assessmentGroup.studentSurveySid
        : UserStore.assessmentGroup.facultySurveySid,
  }
})




});

export default obx;